import { render, staticRenderFns } from "./OrgTag.vue?vue&type=template&id=45e93724&"
import script from "./OrgTag.vue?vue&type=script&lang=js&"
export * from "./OrgTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports